import { FacadeService } from "src/app/shared/service-facade/facade.service";
import { AbandonedCardRules } from "./abandoned-card-rules.abstract"
import { DefaultRulesService } from "./default-rules.service"
import { BaskRulesService } from "./bask-rules.service"

export function AbandonedCardRulesFactory(facade: FacadeService): AbandonedCardRules {
  if (facade.isBaskBrand()) {
    return new BaskRulesService();
  }

  return new DefaultRulesService();
}
